import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-silent-check-sso',
  templateUrl: './silent-check-sso.component.html',
  styleUrls: ['./silent-check-sso.component.scss']
})
export class SilentCheckSsoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
